<script lang="ts">
  import type { OrganizationUser } from "@kontextwerk/control-web-client"
  import UserWorkingHoursEditor from "../../../../../../_shared/_modules/user-working-hours-editor"
  import type { UserViewFrameContext } from "../../../../_shared/_logic/user-types"
  import type { PageContext } from "../../../working-hours/navigation"

  const { viewFrameContext: _viewFrameContext, pageContext } = $props<{
    viewFrameContext: UserViewFrameContext
    pageContext: PageContext
  }>()

  const user = $derived(pageContext.user as OrganizationUser | null)
  const organizationId = $derived(pageContext.organizationId)
  const loading = $derived(pageContext.loading ?? false)
  const error = $derived(pageContext.error ?? null)
  const onRetry = $derived(pageContext.onRetry ?? null)
  const onUpdated = $derived(pageContext.onUpdated ?? (() => {}))
</script>

{#key user?.id ?? "unresolved"}
  <UserWorkingHoursEditor {user} {organizationId} {loading} {error} {onRetry} {onUpdated} />
{/key}
